import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg组件
import generateIconsView from '@/views/svg-icons/generateIconsView.js'// just for @/views/icons , you can delete it

// register globally
Vue.component('svg-icon', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
const iconMap = requireAll(req)

generateIconsView.generate(iconMap) // just for @/views/icons , you can delete it


// import { createApp } from 'vue'
// import App from '../App.vue'
// const app = createApp(App)
// import SvgIcon from '@/components/SvgIcon/index.vue'
// import generateIconsView from '@/views/svg-icons/generateIconsView.js'
//
// // 注册全局组件
// app.component('svg-icon', SvgIcon)
//
// // 使用 Vite 5.x 提供的 import.meta.glob 处理动态导入
// const iconsContext = import.meta.glob('./svg/*.svg')
// const icons = Object.fromEntries(
//   Object.entries(iconsContext).map(([key, value]) => {
//     const name = key.replace(/^\.\//, '').replace(/\.svg$/, '')
//     return [name, value.default]
//   })
// )
//
// generateIconsView.generate(icons)
//
// // 挂载应用
// app.mount('#app')



// WEBPACK FOOTER //
// ./src/icons/index.js